import CustomTextProps from "../../services/models/customTextProps.model";

function CustomText({
  text,
  fontWeight,
  fontSize,
  className,
  showLoadingIndication,
  fontColor,
}: Readonly<CustomTextProps>): JSX.Element {
  return (
    <p
      className={`${fontWeight} text-inherit font-sans ${fontSize} ${className} ${
        showLoadingIndication
          ? "rounded bg-dropDownBorder animate-pulse text-transparent"
          : ""
      }`}
      style={fontColor ? { color: fontColor } : undefined}
    >
      {text}
    </p>
  );
}

export default CustomText;
